export default {
    ai: 'Asistente IA',
    export: 'Exportar',
    blue: 'Azul',
    yellow: 'Amarillo',
    pink: 'Rosa',
    orange: 'Naranja',
    all: 'Todo',
    generateApaCopy: 'Generar cita APA',
    apaCopied: '¡Cita copiada al portapapeles!',
    imReading: 'Estoy leyendo',
    in: 'en',
    by: 'Por',
    article: 'Artículo',
    prevArticle: 'Artículo anterior',
    nextArticle: 'Artículo siguiente',
    imHere: 'Si, estoy aquí',
    sessionExpiredAlert: 'Tu sesión de lectura está por finalizar.',
    sessionExpiredAreYouThere: '¿Estás ahí?',
    sessionExpired: 'Tu sesión de lectura ha finalizado por inactividad.',
    returnToLibrary: 'Volver a la biblioteca',
    sessionValidExpired: 'Sesión expirada',
    sessionValidExpiredPleaseLoginAgain: 'Por favor ingresa nuevamente',
    tableOfContents: 'Tabla de Contenidos',
    tableOfContentsNotAvailable: 'No hay tabla de contenido disponible.',
    pages: 'páginas',
    page: 'página',
    thumbnails: 'Miniaturas',
    settings: 'Configuración',
    bookmarks: 'Marcadores',
    highlights: 'Resaltados',
    highlight: 'Resaltado',
    notes: 'Notas',
    note: 'Nota',
    notebook: 'Anotaciones',
    search: 'Búsqueda',
    theme: 'Tema',
    pageLayout: 'Desplazamiento',
    typography: 'Tipografía',
    fontDefault: 'Por defecto',
    lineSpacing: 'Interlineado',
    lineSpacingCompact: 'Compacto',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Amplio',
    margins: 'Márgenes',
    marginsMinimum: 'Mínimo',
    marginsNormal: 'Normal',
    marginsMaximum: 'Máximo',
    readingModes: 'Modos de lectura',
    zoomTitle: 'Tamaño del texto',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    continuous: 'Continuo',
    onePage: 'Horizontal',
    onePageScroll: 'Vertical',
    twoPages: 'Doble',
    twoPagesScroll: 'Desplazamiento en dos páginas',
    citation: {
        buttons: {
            Iso690: 'Generar cita ISO690',
            APA: 'Generar cita APA',
            Vancouver: 'Generar cita Vancouver',
            Chicago: 'Generar cita Chicago',
            ChicagoNotes: 'Notas',
            ChicagoBibliography: 'Bibliografía',
            ChicagoAuthorDate: 'Autor-Fecha',
            IEEE: 'Generar cita IEEE',
            MLA: 'Generar cita MLA',
            ABNT: 'Generar cita ABNT',
        },
        menu: {
            title: 'Generar cita',
            Iso690: 'Cita ISO690',
            APA: 'Cita APA',
            Vancouver: 'Cita Vancouver',
            Chicago: 'Cita Chicago',
            ChicagoNotes: 'Notas',
            ChicagoBibliography: 'Bibliografía',
            ChicagoAuthorDate: 'Autor-Fecha',
            IEEE: 'Cita IEEE',
            MLA: 'Cita MLA',
            ABNT: 'Cita ABNT',
        },
        messages: {
            copied: '¡Cita copiada al portapapeles!',
            availableIn: 'Disponible en',
            online: 'En Línea',
            generated: 'consultado',
            websiteName: 'publica.la',
            and: 'y',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Explicar concepto',
            expand: 'Ampliar información',
            summarize: 'Resumir la idea',
        },
        menu: {
            title: 'Asistente IA (Beta)',
        },
        messages: {
            copied: '¡Respuesta copiada al portapapeles!',
            addedToResponse: '«Respuesta copiada de publica.la Reader»',
        },
        thanksFeedback: '¡Gracias por tu devolución!',
        errorFeedback: 'Falló el envio de tu devolución. ¿Puedes reintentar?',
    },
    onlyCopy: 'Copiar sin formato',
    translate: 'Traductor',
    copy: 'Copiar',
    changeColor: 'Cambiar color',
    socialShare: 'Compartir',
    zoom: {
        auto: 'Automático',
        'page-fit': 'Ajustar página',
        'page-width': 'Ancho de página',
    },
    filter: 'Filtrar',
    noFilterHighlights: 'Selecciona algún color para visualizar tus resaltados',
    noFilterHighlightsColor: 'No hay ningun resaltado en este color',
    noHighlights: 'Aún no has creado ningún resaltado',
    noFilterNotes: 'Selecciona algún color para visualizar tus notas',
    noFilterNotesColor: 'No hay ninguna nota en este color',
    noNotes: 'Aún no has escrito ninguna nota',
    noFilterHighlightsAndNotes: 'Selecciona algún color para visualizar tus resaltados y notas',
    noFilterHighlightsAndNotesColor: 'No hay ninguna nota o resaltado en este color',
    noHighlightsAndNotes: 'Aún no has creado ningun resaltado o nota',
    plainCopied: '¡Texto copiado al portapapeles!',
    onboarding: {
        next: 'Siguiente',
        finish: 'Finalizar',
        skip: 'Saltar tutorial',
        previous: 'Anterior',
        reader: {
            welcome: {
                title: 'Bienvenido a tu espacio de lectura',
                paragraph:
                    'Descubre cómo sacarle el máximo partido a tus libros con las herramientas disponibles en el lector.',
                extraParagraph: '¡Disfruta de tu nuevo espacio de lectura!',
            },
            highlights: {
                title: 'Mejora tu experiencia de lectura',
                paragraph:
                    'Selecciona texto, resalta, crea notas, genera citas, traduce y escucha el contenido. Lleva tu experiencia de lectura al siguiente nivel en todos los formatos.',
            },
            resumes: {
                title: 'Gestiona tu contenido',
                paragraph:
                    'Aumenta tu productividad. Gestiona tus notas, resaltados, citas y resúmenes, según tu conveniencia. Comparte tus ideas de forma rápida y sencilla.',
            },
            appPromote: {
                title: 'Lee o escucha en cualquier lugar',
                paragraph:
                    'Ten acceso a tu contenido cuando y como quieras, sin necesidad de conexión a internet, en el dispositivo de tu conveniencia.',
                extraParagraph: '¡Descarga nuestra app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Bienvenido',
                subTitle: '¿Cómo usar el reproductor?',
                paragraph: 'Aprende a utilizar las funciones y aprovechar al máximo el reproductor.',
            },
            reproduction: {
                title: 'Control de la reproducción',
                paragraph: 'Adelanta, retrasa o pausa la reproducción del audiobook.',
            },
            narratorSpeed: {
                title: 'Aumentar y reducir la velocidad de la narración',
                paragraph: 'Puedes elegir la velocidad con la que se escucha el audiobook, según lo prefieras.',
            },
            chapters: {
                title: 'Adelantar y regresar en capítulos',
                paragraph: 'Muévete entre capítulos de una manera ágil y rápida.',
            },
        },
    },
    author: 'Autor',
    publisher: 'Editorial',
    narrator: 'Narrador',
    narratedBy: 'Narrado por',
    aboutThisPublication: 'Acerca de esta publicación',
    listening: {
        label: 'Escuchar',
        voice: 'Voz',
    },
    searchResultEmpty: 'No se encontraron resultados',
    searchLengthError: 'La búsqueda debe tener entre 4 y 128 caracteres',
    keepTyping: 'Sigue escribiendo…',
    loading: 'Cargando...',
    searchLoading: 'Buscando...',
    searchTitle: 'Buscador',
    lastSearch: 'Sugerencias',
    searchExplanation: 'Encuentra palabras de manera ágil en toda la publicación',
    networkIsOffline: 'No hay conexión a internet. Algunas características no estan disponibles.',
    about: 'Acerca de',
    chapters: 'Capítulos',
    duration: 'Duración',
    narratorSpeed: 'Velocidad de narración',
    slowNarration: 'Narración lenta',
    normalNarration: 'Narración normal',
    fastNarration: 'Narración rápida',
    shareIssue: 'Compartir publicación',
    shareArticle: 'Compartir artículo',
    copyUrl: 'Copiar URL',
    shareCurrentPage: 'Compartir página actual',
    shareCurrentPosition: 'Compartir posición actual',
    copyUrlToClipboard: 'URL copiada al portapapeles',
    tooltips: {
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        config: 'Configuración',
        tableOfContents: 'Tabla de contenido',
        search: 'Buscar',
        highlights: 'Resaltados',
        notebook: 'Anotador',
        listen: 'Audio',
        bookmarks: 'Marcadores',
        openThumbnails: 'Miniaturas',
        closeThumbnails: 'Salir de miniaturas',
        download: 'Acceso Offline',
        share: 'Compartir',
        prev: 'Anterior',
        next: 'Siguiente',
        close: 'Cerrar',
        back: 'Atrás',
        themeTitle: 'Apariencia',
        themeLight: 'Claro',
        themeDark: 'Oscuro',
        themeCream: 'Crema',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Alto contraste',
        themeHighContrastDark: 'Alto contraste oscuro',
        clear: 'Limpiar',
        citation: 'Cita',
        createHighlight: 'Resaltado',
        dictionary: 'Diccionario',
        aiIntegrations: 'Asistente IA (Beta)',
        aiAction:
            'Esta herramienta usa IA, por lo que puede haber información imprecisa. ¡Pronto habrá mejoras! ¿Qué opinás? Usa los íconos abajo para expresarte.',
        translate: 'Traductor',
        about: 'Acerca de',
        rewind: 'Rebobinar',
        forward: 'Adelantar',
        createNote: 'Notas',
        deleteHighlight: 'Borrar resaltado',
        help: 'Ayuda',
        lists: 'Listas',
        copy: 'Copiar',
        goodResponse: 'Buena respuesta',
        badResponse: 'Mala respuesta',
        ai: 'Asistente ia',
        moreActions: 'Más acciones',
        moreOptions: 'Más opciones',
        selectionTools: 'Herramientas de selección',
        play: 'Reproducir',
        pause: 'Pausar',
        seekPosition: 'Posición de la pista',
        zoomReset: 'Restablecer zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Tema del sistema',
        searchInBook: 'Buscar en el libro',
        pageSlider: 'Navegación de página',
    },
    save: 'Guardar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirmDelete: {
        title: 'Eliminar Anotacion',
        message: '¿Estás seguro de que deseas eliminar esta anotacion? Esta acción no se puede deshacer.',
    },
    confirmResetSettings: {
        title: 'Restablecer configuración',
        message: 'Todas las configuraciones visuales volverán a sus valores por defecto.',
    },
    resetSettings: 'Restablecer valores',
    writeNote: 'Escribe una nota',
    speakNow: 'Habla ahora',
    listeningSpeech: 'Escuhando',
    share: {
        copyShare: 'Copiar y compartir',
        qrCodeTitle: 'Código QR',
        scanQr: 'Scanea el código QR usando WeChat',
        copyLink: 'Copiar el link de la publicación',
        copy: 'Copiar',
        copied: '¡Copiado!',
        openWechat: 'Abrir WeChat',
        openingWechat: 'Abriendo WeChat...',
        sendCopiedUrl: 'Enviar la URL copiada a tu contacto',
    },
    playing: 'Reproduciendo',
    buyNow: 'Comprar ahora',
    buyNowText: 'Obtén la versión completa.',
    preview: 'Muestra',
    changeLayoutNotAllowed: 'El contenido no permite cambiar la configuración de página.',
    nativeTtsLang: {
        'en-US': 'Inglés (Estados Unidos)',
        'en-GB': 'Inglés (Reino Unido)',
        'en-scotland': 'Inglés (Escocia)',
        'en-AU': 'Inglés (Australia)',
        'en-IE': 'Inglés (Irlanda)',
        'en-IN': 'Inglés (India)',
        'en-ZA': 'Inglés (Sudafrica)',
        en: 'Inglés',
        'es-AR': 'Español (Argentina)',
        'es-ES': 'Español (España)',
        'es-MX': 'Español (México)',
        'es-US': 'Español (Estados Unidos)',
        es: 'Español',
        'it-IT': 'Italiano (Italia)',
        it: 'Italiano',
        'pt-PT': 'Portugués (Portugal)',
        'pt-BR': 'Portugués (Brasil)',
        pt: 'Portugués',
        'fr-CA': 'Francés (Canada)',
        'fr-FR': 'Francés (Francia)',
        fr: 'Francés',
        pl: 'Polaco',
        'pl-PL': 'Polaco (Polonia)',
    },
    promoteApp: {
        downloadAppStore: 'Descárgalo en el App Store',
        downloadPlayStore: 'Disponible en Google Play',
        title_read: 'Lleva tus lecturas a donde vayas con',
        title_audio: 'Lleva tus audiolibros a donde vayas con',
        text: 'Ten acceso a tu contenido cuando y como quieras, sin necesidad de conexión a internet, en el dispositivo de tu conveniencia. ¡Descarga nuestra app!',
        title_first_part: 'Con',
        title_second_part: 'lleva tus lecturas a donde vayas',
    },
    dictionary: 'Diccionario',
    selectionTooLongLine1: 'La selección contiene muchas palabras.',
    selectionTooLongLine2: 'Prueba seleccionar hasta 5 palabras.',
    dictionaryValidation: {
        message: 'Seleccionaste {count} palabras.\nPor favor, intenta seleccionar hasta {max} palabras.',
    },
    translateValidation: {
        message: 'Seleccionaste {count} caracteres.\nPor favor, intenta seleccionar hasta {max} caracteres.',
    },
    ttsValidation: {
        message: 'Seleccionaste {count} caracteres.\nPor favor, intenta seleccionar hasta {max} caracteres.',
    },
    aiValidation: {
        message: 'Seleccionaste {count} caracteres.\nPor favor, selecciona entre {min} y {max} caracteres.',
    },
    alreadyPurchased: '¿Ya compraste?',
    logIn: 'Inicia sesión',
    addToAList: 'Agregar a lista',
    lists: 'Listas',
    nextSection: 'Siguiente sección',
    prevSection: 'Sección anterior',
    new: 'Nuevo',
    skipLinks: {
        navLabel: 'Enlaces de acceso rápido',
        showControls: 'Mostrar controles',
    },
    accessibility: {
        textSelected: '{count} caracteres seleccionados. Herramientas de selección disponibles.',
        pageChanged: 'Página {current} de {total}',
    },
};
